import { render, staticRenderFns } from "./Import.vue?vue&type=template&id=03b63bf2&scoped=true&"
import script from "./Import.vue?vue&type=script&lang=js&"
export * from "./Import.vue?vue&type=script&lang=js&"
import style0 from "./Import.vue?vue&type=style&index=0&id=03b63bf2&lang=scss&scoped=true&"
import style1 from "./Import.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b63bf2",
  null
  
)

export default component.exports